import About from './components/About/About';
import Main from './components/Main/Main';
import { Routes, Route } from "react-router-dom";
import ScrollToTop from './components/ScrollToTop';
import Partnership from './components/Partnership/Partnership';
import Contact from './components/Contact/Contact';
import PopularMenu from './components/PopularMenu/PopularMenu';
import GetApp from './components/GetApp/GetApp';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Franchisee from "./components/Franchisee/Franchisee";
import Partner from './components/Partner/Partner';
import Driver from './components/Driver/Driver';
import Footer from './components/Footer/Footer';
import Navbar from './components/Navbar/Navbar';
import { FaWhatsapp } from 'react-icons/fa';
import './components/Main.css';

function App() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/aboutus" element={<About />} />
        <Route path="/partnership" element={<Partnership />} />
        <Route path="/contactus" element={<Contact />} />
        <Route path="/popularmenu" element={<PopularMenu />} />
        <Route path="/getapp" element={<GetApp />} />
        <Route path="/franchisee" element={<Franchisee />} />
        <Route path="/partner" element={<Partner />} />
        <Route path="/driver" element={<Driver />} />
      </Routes>

      <Footer />

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/919786221122"
        target="_blank"
        rel="noopener noreferrer"
        className="floating-whatsapp-btn"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp size={30} />
      </a>

    </>
  );
}

export default App;